import { render, staticRenderFns } from "./SubscribeFreeElements.vue?vue&type=template&id=5da447a6&scoped=true&"
import script from "./SubscribeFreeElements.vue?vue&type=script&lang=js&"
export * from "./SubscribeFreeElements.vue?vue&type=script&lang=js&"
import style0 from "./SubscribeFreeElements.vue?vue&type=style&index=0&id=5da447a6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5da447a6",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {FreeEdmForm: require('/opt/render/project/src/channels2022/src/components/free/FreeEdmForm.vue').default})
